import { EmploymentPeriodDTO, OrganisationToPersonDTO } from 'api/core/models';
import { CheckPermissionFunction } from 'Auth/components/PermissionGate';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import React, { ReactNode } from 'react';
import { EmploymentPeriods } from './EmploymentPeriods';
import { getDefaultOrganisationPerson } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { JustifiedDeleteButton } from '../../../components/form/MultiInput/Buttons';
import { Panel } from '../layout/Panel';
import { LabelledPersonSuggester } from '../../../components/form/LabelledPersonSuggester';
import { Fieldset } from '../layout/Fieldset';
import {
  referencedPersonToSelectedPerson,
  SelectedPerson,
  selectedPersonToReferencedPerson,
} from '../suggester/PersonSuggester';

interface Props {
  title: string;
  checkPermission: CheckPermissionFunction;
  organisationPersons: OrganisationToPersonDTO[];
  onChange: (po: OrganisationToPersonDTO[]) => void;
  validation?: ValidationResult;
  autoFocus: boolean;
}

export const OrganisationPersons = (props: Props): ReactNode => {
  return (
    <Panel title={props.title} toggleable={true}>
      <MultiInputControls<OrganisationToPersonDTO>
        canEdit={props.checkPermission().canWrite}
        addNew={(rows: OrganisationToPersonDTO[]): number => rows.push(getDefaultOrganisationPerson())}
        lines={props.organisationPersons}
        onChange={props.onChange}
        renderLines={(organisationPerson: OrganisationToPersonDTO, onLineChange: (po: OrganisationToPersonDTO) => void, actions: Actions, idx: number) => (
          <Fieldset pt={{root: {className: 'surface-50'}}}>
            {props.checkPermission('person').canRead && (
              <LabelledPersonSuggester
                value={organisationPerson.person ? [referencedPersonToSelectedPerson(organisationPerson.person)] : []}
                autoFocus={props.autoFocus}
                id={`organisationPerson${idx}`}
                permissions={props.checkPermission('person')}
                multiple={false}
                validation={props.validation?.children[idx]?.fields?.person}
                onChange={(ref: SelectedPerson[]): void => onLineChange({
                  ...organisationPerson,
                  person: ref.length > 0 ? selectedPersonToReferencedPerson(ref.pop()) : undefined,
                })}
                label={`${props.title}.attr.person`}
              />
            )}
            <EmploymentPeriods
              autoFocus={props.autoFocus}
              title={`${props.title}.attr.employmentPeriods`}
              validation={props.validation?.children[idx]?.fields?.employment_periods}
              checkPermission={props.checkPermission}
              employmentPeriods={organisationPerson.employmentPeriods}
              onChange={(employmentPeriods: EmploymentPeriodDTO[]): void => {
                onLineChange({...organisationPerson, employmentPeriods});
              }}
            />
            <JustifiedDeleteButton onClick={actions.delete} disabled={!props.checkPermission().canWrite}/>
          </Fieldset>
        )}
      />
    </Panel>
  );
};
